import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicSubscriptionsApi } from '../../../apis/ClinicSubscriptionsApi/ClinicSubscriptionsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

interface ReleaseClinicSeatParams {
    clinicId: string;
    userId: string;
}

export const useReleaseClinicSeat = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ clinicId, userId }: ReleaseClinicSeatParams) => 
            ClinicSubscriptionsApi.releaseSeat(clinicId, userId),
        onSuccess: (_, { clinicId }) => {
            // Invalidate clinic seat usage related queries
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareFacility] });
            // Invalidate the specific clinic seat usage query
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage, clinicId] });
            // Also invalidate the all clinic seat usages query
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage, 'all'] });
        },
    });
}; 